import React from 'react';
import { ReactComponent as Dashboard } from '../../assets/ic_dashboard.svg';

const DashboardIcon = () => <Dashboard />;

export default DashboardIcon;
